/**
 * https://github.com/tldraw/tldraw/blob/daf729d45c879d4e234d9417570149ad854f635b/packages/utils/src/lib/error.ts
 */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const annotationsByError = new WeakMap();
/**
 * Annotate an error with tags and additional data. Annotations won't overwrite existing ones.
 * Retrieve them with `getErrorAnnotations`.
 *
 * @internal
 */ export function annotateError(error, annotations) {
    if (typeof error !== 'object' || error === null) return;
    let currentAnnotations = annotationsByError.get(error);
    if (!currentAnnotations) {
        currentAnnotations = {
            tags: {},
            extras: {}
        };
        annotationsByError.set(error, currentAnnotations);
    }
    if (annotations.tags) {
        currentAnnotations.tags = _object_spread({}, currentAnnotations.tags, annotations.tags);
    }
    if (annotations.extras) {
        currentAnnotations.extras = _object_spread({}, currentAnnotations.extras, annotations.extras);
    }
}
/** @internal */ export function getErrorAnnotations(error) {
    var _annotationsByError_get;
    return (_annotationsByError_get = annotationsByError.get(error)) !== null && _annotationsByError_get !== void 0 ? _annotationsByError_get : {
        tags: {},
        extras: {}
    };
}
